import { render, staticRenderFns } from "./TotalEntriesList.vue?vue&type=template&id=60dfaa17&"
import script from "./TotalEntriesList.vue?vue&type=script&lang=js&"
export * from "./TotalEntriesList.vue?vue&type=script&lang=js&"
import style0 from "./TotalEntriesList.vue?vue&type=style&index=0&id=60dfaa17&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports